import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getOpenSourceByApplicationId(applicationId: string) {
  return await prisma.applicantOpenSource.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
